"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggablePieChart_1 = require("./PluggablePieChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var PieChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(PieChartDescriptor, _super);
    function PieChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggablePieChart_1.PluggablePieChart(params); };
    };
    return PieChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.PieChartDescriptor = PieChartDescriptor;
//# sourceMappingURL=PieChartDescriptor.js.map